import { useEffect, useState } from 'react';
import { useWindowDimensions } from 'react-native';

export const Breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export function useBreakpoint() {
  const { width: windowWidth } = useWindowDimensions();
  // During static web export the server has no `window`, so react-native-web
  // reports a width of 0 and every layout renders mobile-first into the HTML.
  // The client, however, knows the real width on its very first render, so it
  // would immediately render the desktop layout and mismatch the server markup
  // (React hydration error #418). Gate the real width behind a mount flag so the
  // first client render matches the server, then re-render with real dimensions.
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const width = mounted ? windowWidth : 0;

  return {
    width,
    isSm: width >= Breakpoints.sm,
    isMd: width >= Breakpoints.md,
    isLg: width >= Breakpoints.lg,
    isXl: width >= Breakpoints.xl,
  };
}
